module.exports = __webpack_public_path__ + "static/media/500px.664e2c8b.svg";